import { selectCartQuantity, selectCheckoutLink } from "@redux/selectors"
import { Dispatch, RootState } from "@redux/store"
import { isNilOrEmpty } from "@utils/index"
import { connect } from "react-redux"

import CartToast from "../index"

const mapState = (state: RootState) => {
  return {
    cartCount: selectCartQuantity(state),
    checkoutLink: selectCheckoutLink(state),
    isOpen:
      !isNilOrEmpty(state.checkout.toastProduct) &&
      !state.checkout.showPromoToast,
    product: state.checkout.toastProduct,
  }
}

const mapDispatch = (dispatch: Dispatch) => ({
  onRequestClose: () => {
    dispatch.checkout.updateToastProduct(null)
  },
})

export default connect(mapState, mapDispatch)(CartToast)
